import { alpha } from '@mui/system';
import { themeObject } from 'lib';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { commonStyles } from 'pages/pipelines/pipelines-helper';

export interface SortableSearchListItemProps {
    data: Record<string, string>;
    type: ItemType;
    handleActionsClick?: (
        dataWithAction: SortableListItemDataWithAction
    ) => void;
    showItemMenu?: boolean;
}

export const sortableSearchListItemStyles = {
    listItemContainerStyles: {
        width: '100%',
        display: 'flex',
        gap: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: '13px 20px',
        borderRadius: '8px',
        backgroundColor: themeObject.palette.background.paper,
        boxShadow: `
                0px 0px 3px 0px ${alpha(themeObject.palette.grayScale[700], 0.2)},
                0px 1px 1px 0px ${alpha(themeObject.palette.grayScale[700], 0.2)},
                0px 2px 1px -1px ${alpha(themeObject.palette.grayScale[700], 0.2)}
                `,
    },
    sortableItemStyles: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        gap: 1,
    },
    sortableItemContainerStyles: {
        display: 'flex',
        gap: 1,
        width: 'calc(100% - 70px)',
    },
    sortableItemLabelStyles: {
        minWidth: 'fit-content',
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.semibold,
    },
    sortableItemValueStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
    },
    menuItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
    },
    menuItemTextStyles: {
        ...themeObject.typography.Components.menuItem,
        lineHeight: '27px',
        color: themeObject.palette.grayScale[800],
    },
    menuItemHeight: {
        height: '49px',
    },
};

export interface SortableListItemDataWithAction {
    action: string;
    data: Record<string, string>;
}

export const getMenuItems = (
    type: string
): {
    label: string;
    icon: JSX.Element;
}[] => [
    {
        label: `Edit ${type}`,
        icon: <EditIcon sx={commonStyles.editIconStyles} />,
    },
    {
        label: `Delete ${type}`,
        icon: <DeleteIcon sx={commonStyles.deleteIconStyles} />,
    },
];

export interface ConfigField {
    label: string;
    getValue: (data: any) => string;
}

export type ItemConfigReturnType = {
    'Field Mapping': ConfigField[];
    'Rule Set': ConfigField[];
};

export type ItemType = keyof ItemConfigReturnType;

export const ITEM_CONFIG: ItemConfigReturnType = {
    'Field Mapping': [
        {
            label: 'Inbound Name',
            getValue: (data: any) => Object.keys(data)[0] ?? '',
        },
        {
            label: 'Field Name',
            getValue: (data: any) => Object.values(data)[0] as string,
        },
    ],
    'Rule Set': [
        { label: 'Name', getValue: (data: any) => data.name ?? '' },
        {
            label: 'Description',
            getValue: (data: any) => data.description ?? '',
        },
    ],
};
